import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api'; // ✅ FIX 2: Imported authAPI

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Hydrate user state from localStorage on page reload
  useEffect(() => {
    const storedToken = localStorage.getItem('access_token');
    const storedUser = localStorage.getItem('user');
    
    if (storedToken && storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser({ token: storedToken, ...parsedUser });
      } catch (e) {
        console.error("Failed to parse stored user data");
        localStorage.removeItem('access_token');
        localStorage.removeItem('user');
      }
    }
    setLoading(false);
  }, []);

  // ✅ FIX 1: Correct signature (email, password), handles API call, returns success/error object
  const login = async (email, password) => {
    try {
      const response = await authAPI.login(email, password);
      const { access_token, role, name } = response.data;
      const userData = { name, email, role };
      
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('user', JSON.stringify(userData));
      setUser({ token: access_token, ...userData });
      
      return { success: true };
    } catch (error) {
      const message = error.response?.data?.detail || 'Authentication failed. Please check your credentials.';
      return { success: false, error: message };
    }
  };

  // ✅ FIX 3: Added hard redirect to '/login' after clearing state
  const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
    setUser(null);
    window.location.href = '/login'; 
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};